define('specific/apibridge/ApiBridge', [

], function() {

    var config = {},
        customerId = null,
        filters = [],
        hasNext = true,
        nextLink,
        pendings = [],
        authToken = null,
        filterPattern = /^og-*/i,
        codeYPattern = /^y[0-9]{7,8}$/i,
        codeFPattern = /^f[0-9]{9}$/i;

    var _isCodeSku = function(item) { return codeFPattern.test( item.tag_based_key ); },
        _isCodeY = function(item) { return codeYPattern.test( item.tag_based_key ); },
        _isNotFilter = function(item) { return !filterPattern.test( item.tag_based_key ); };

    /*
     * Add config & callback
     */
    var initialize = function(options) {
        config = options.config ? options.config : {};
        authToken = options.authToken || '63748a2c735df7b770194018028bf5688a6246468d05de8619feaf6c35815b21';
        customerId = options.customerId || '218526';
        nextLink = "initialize";
    };

    var updateFilters = function( _filters ) {
        // console.log('[ApiBrigde] => Update Filters', _filters);

        filters = _filters;
        pendings = [];
        hasNext = true;
        nextLink = "";
    };

    /*
     * Call Olapic Api
     */
    var requestDatas = function( nbImagesRequested, callback, cleanDatas ) {

        if( pendings.length < nbImagesRequested && hasNext ) {
            // console.log('[ApiBrigde] => not enough datas need to request some');

            var link = "",
                paramas = "";

            if( typeof nextLink === 'undefined' || !nextLink ) {
                if( filters[0] === customerId ) {
                    link = 'https://photorankapi-a.akamaihd.net/customers/' + filters[0] + '/media/recent';
                    params = 'auth_token=' + authToken + '&version=v2.2';
                } else {
                    link = 'https://photorankapi-a.akamaihd.net/streams/' + filters[0] + '/media/recent';
                    params = 'auth_token=' + authToken + '&version=v2.2';
                }
            } else {
                var splittedLink = nextLink.split('?');
                link = splittedLink[0];
                params = splittedLink[1];
            }

            // console.log('[ApiBrigde] => requestDatas', link, params, nbImagesRequested, pendings.length);

            $.ajax({
                url: link,
                method: 'GET',
                contentType: 'application/json',
                data: params,
                dataType: 'json',
                success: _.bind( function( response ) {
                    nextLink = response.data._links.next.href;
                    hasNext =  nextLink !== null;

                    var images = [],
                        medias = response.data._embedded.media;

                    for( var i = 0; i < medias.length; i++ ) {
                        var stream = medias[i]._embedded['streams:all']._embedded.stream,
                            _products = [];

                        if( config.isPcd ) {
                            var _codeY = _.filter( stream, _isCodeY ),
                                _skus = _.filter( stream, _isCodeSku );

                            for( var j = 0; j < _codeY.length; j++ ) {
                                var skus = _.where( _skus, { name: _codeY[j].name } );

                                if( skus.length > 0 ) {
                                    for( var k = 0; k < skus.length; k++ ) {
                                        _products.push({
                                            codeY: _codeY[j].tag_based_key,
                                            defaultSku: skus[k].tag_based_key
                                        });
                                    }
                                } else {
                                    _products.push({
                                        codeY: _codeY[j].tag_based_key,
                                        defaultSku: null
                                    });
                                }
                            }
                        } else {
                            _products = _.filter( stream, _isNotFilter );
                        }

                        images.push({
                            id: medias[i].id,
                            username: medias[i]._embedded.uploader.username,
                            src: medias[i].images.original,
                            caption: medias[i].caption,
                            original_source: medias[i].original_source,
                            video_url: medias[i].video_url,
                            likes: medias[i].likes,
                            products: _products
                        });
                    }

                    pendings = pendings.concat( images );
                    // console.log( '[ApiBrigde] add images to pendings => ', pendings );
                    requestDatas( nbImagesRequested, callback, cleanDatas );
                }, this),
                error: _.bind( function( error ) {
                    // console.log('[ApiBridge] Error => ', error );
                    callback( [], true, false );
                }, this)
            });
        } else {
            var obj = pendings.splice(0, nbImagesRequested);

            hasMoreItems = pendings.length !== 0 || hasNext;

            // console.log( '[ApiBrigde] nbImagesRequested reached => pendings', pendings );

            callback( obj, cleanDatas, hasMoreItems );
        }
    };

    return {
        initialize: initialize,
        updateFilters: updateFilters,
        requestDatas: requestDatas
    };

});
